import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureUi, installChunkReload } from '@classroom-ai/ui';
import { ErrorBoundary } from '@classroom-ai/ui/routes/components';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';

import App from './app';
import { paths } from './routes/paths';
import { CONFIG } from './global-config';
import { routesSection } from './routes/sections';

// ----------------------------------------------------------------------

// Reload once if a lazy route chunk is stale after a hosting deploy (see packages/ui/src/chunk-reload.ts).
installChunkReload();

configureUi({
  appName: CONFIG.appName,
  appVersion: CONFIG.appVersion,
  auth: { redirectPath: CONFIG.auth.redirectPath },
  routes: {
    signIn: paths.auth.firebase.signIn,
    signUp: paths.auth.firebase.signUp,
    resetPassword: paths.auth.firebase.resetPassword,
    verify: paths.auth.firebase.verify,
    dashboardRoot: paths.dashboard.root,
  },
});

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorBoundary />,
    children: routesSection,
  },
]);

const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
